import { OpenInNew } from "@mui/icons-material";
import { Box, Button, Paper, Typography } from "@mui/material";
import { useTheme } from "../contexts/ThemeContext";

const DocumentationPage = () => {
    const { darkMode } = useTheme();
    // URL dinámica basada en variables de entorno
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";
    const apiDocsUrl = `${apiBaseUrl}/docs`;

    return (
        <Box>
            <Box
                sx={{
                    mb: 3,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Typography variant="h4" component="h1">
                    Documentación de la API
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<OpenInNew />}
                    onClick={() =>
                        window.open(apiDocsUrl, "_blank", "noopener,noreferrer")
                    }
                >
                    Abrir en nueva pestaña
                </Button>
            </Box>

            <Paper
                elevation={3}
                sx={{
                    height: "calc(100vh - 200px)",
                    overflow: "hidden",
                    backgroundColor: darkMode ? "#121212" : "#ffffff",
                    position: "relative",
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: darkMode ? "#121212" : "#ffffff",
                        zIndex: 0,
                    }}
                />
                <iframe
                    src={apiDocsUrl}
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    title="Documentación API FastAPI"
                    style={{
                        border: "none",
                        position: "relative",
                        zIndex: 1,
                        backgroundColor: "white",
                    }}
                />
            </Paper>
        </Box>
    );
};

export default DocumentationPage;
